import {Button} from 'antd'
import {exam_getExaminationInfos_Api} from 'apis'
import {getId, getType} from 'apis/model/base'
import getTitle from 'helpers/getTitle'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext} from 'react'
import {compose, fromRenderProps} from 'recompose'
import EntityList from 'views/AppLocals/EntityList'
import {ExamProvider} from 'views/AppLocals/Exam/ExamContext'
import ExaminationContext from 'views/AppLocals/Exam/ExaminationContext'
import ExaminationInfoContext, {ExaminationInfoProvider,} from 'views/AppLocals/Exam/ExaminationInfoContext'
import {bindQueryParam} from 'views/AppLocals/functions/routerHelper'
import {NullAsDefault} from 'views/Shared'
import CRUD from 'views/Shared/enums/CRUD'

const renderExaminationInformation =
  ({ renderContextMenu }) =>
  (item, index) => {
    const {
      description,
      answer_type,
      is_mandatory,
      examination_info_answers = [],
    } = item || {}
    return (
      <Translate key={index}>
        {(t) => (
            <div className="flex flex-col p-3 border border-color-50 hover:text-color-100 hover:shadow-items-md rounded-lg relative">
                <div className="flex items-baseline gap-1 leading-tight mb-1">
              <span className="text-sm text-color-300 font-light italic">
                {`${t('ask')}: `}
              </span>
                    <span className="text-color-000 font-medium">
                {getTitle(item)}
              </span>
                </div>
                {description && (
                    <div className="text-sm font-light italic mb-1">
                        {description}
                    </div>
                )}
                <div className="grid grid-cols-2 gap-1">
                    <div className="flex items-baseline gap-1 leading-tight text-xs">
                <span className="text-color-500 font-light italic">{`${t(
                    'mandatory'
                )}: `}</span>
                        <span className="text-color-100 font-medium">
                  {is_mandatory === 1 ? t('yes') : t('no')}
                </span>
                    </div>
                    <div className="flex items-baseline gap-1 leading-tight text-xs">
                <span className="text-color-500 font-light italic">{`${t(
                    'answers'
                )}: `}</span>
                        <span className="text-color-100 font-medium">
                  {examination_info_answers.length}
                </span>
                    </div>
                    <div className="flex items-baseline gap-1 leading-tight text-xs">
                <span className="text-color-500 font-light italic">{`${t(
                    'answer type'
                )}: `}</span>
                        <span className="text-color-100 font-medium">
                  {t(answer_type)}
                </span>
                    </div>
                </div>
                <div className="absolute right-0 top-0 p-1">
                    {renderContextMenu(item)}
                </div>
            </div>
        )}
      </Translate>
    )
  }

const ExaminationSettingInformation = () => {
  const t = useTranslate()

  const {
    refreshKey,
    examination_id,
    handleAction = NullAsDefault,
    renderContextMenu = NullAsDefault,
  } = useContext(ExaminationInfoContext)

  return (
    <div className="flex flex-col space-y-3">
      <div className="flex items-center justify-between gap-2 mb-1">
        <span className="text-sm font-medium text-color-300 leading-tight uppercase">
          {t('additional information')}
        </span>
        <Button
          type="primary"
          size="small"
          className="flex flex-center button-rounded-md no-border font-medium text-xs px-4"
          onClick={() => {
            handleAction(CRUD.CREATE)
          }}>
          {t('create new')}
        </Button>
      </div>
      <EntityList
        key={refreshKey}
        RenderEntity={React.Fragment}
        apiInfo={exam_getExaminationInfos_Api}
        query={bindQueryParam({ id: examination_id })}
        renderItem={renderExaminationInformation({
          renderContextMenu,
        })}
      />
    </div>
  )
}

export default compose(
  fromRenderProps(ExaminationContext.Consumer, ({ examination }) => ({
    owner_id: getId(examination),
    owner_type: getType(examination),
  }))
)(({ owner_id, owner_type }) => (
  <ExamProvider {...{ owner_id, owner_type }}>
    <ExaminationInfoProvider examination_id={owner_id}>
      <ExaminationSettingInformation />
    </ExaminationInfoProvider>
  </ExamProvider>
))
